// extracted by mini-css-extract-plugin
export default {"verificationBannerItem":"VerifyEmail_verificationBannerItem__kFO+s","verificationAcrLogo":"VerifyEmail_verificationAcrLogo__tK70x"};